module.exports = __webpack_public_path__ + "static/media/external_link.2fdfdb43.svg";